import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Helmet } from '@dr.pogodin/react-helmet'
import { Divider, Stack, Typography } from '@mui/material'
import ConvertiblesApi from '../../../../api/ConvertiblesApi'
import { ConvertibleEntity } from 'types/ConvertibleEntity'
import AdminEditConvertibleForm from './AdminEditConvertibleForm'

const AdminEditConvertible = () => {
    const [convertible, setConvertible] = useState<ConvertibleEntity | null>(null)
    const { convertibleId } = useParams()
    const convertiblesApi = new ConvertiblesApi()
    const { t } = useTranslation()

    const fetchData = async (id: string) => {
        const convertible = await convertiblesApi.findByConvertibleId(id, false)
        setConvertible(convertible)
    }

    useEffect(() => {
        if (!convertibleId) return
        void fetchData(convertibleId)
    }, [convertibleId])

    const pageTitle = t('site.convertibles.detailsTitle', { name: convertible?.convertibleName || '' })

    return (
        <>
            <Helmet title={pageTitle} />
            <Typography variant='h3' gutterBottom display='block'>
                {pageTitle}
            </Typography>

            <Stack direction='row' spacing={4}>
                {/* <WarrantStatusDescription warrant={warrantToShowStatus} /> */}
                <Typography variant='body1'>
                    <Link to={`/convertibles/${convertibleId}`}>[Visa detaljvy]</Link>
                </Typography>
                {convertible?.companyId ? (
                    <Typography variant='body1'>
                        <Link to={`/companies/${convertible.companyId}`}>[Visa bolagsvy]</Link>
                    </Typography>
                ) : null}
            </Stack>

            <Divider sx={{ my: 6 }} />
            {convertibleId && convertibleId !== 'new' && convertible && (
                <AdminEditConvertibleForm convertible={convertible} refetchData={fetchData} />
            )}
        </>
    )
}

export default AdminEditConvertible
